import { useDispatch, useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { Menu, MenuItem, Typography, useMediaQuery } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import FadeMenu from "./DropDownMenu";
import React, { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { logout } from "../../slices";
import { Alert } from "@mui/material";

function AppHeader() {
  const { role, config } = useSelector((state) => state.user);
  const location = useLocation();
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useMediaQuery("(max-width: 960px)");
  const open = Boolean(anchorEl);
  let userName = "";
  let UIN = "";
  let profilRegister = "";
  let profilEmail = "";
  if (token) {
    const decodedToken = jwtDecode(token);
    if (role === "patient") {
      userName = decodedToken.pac || "No patient name!";
    } else if (role === "doctor") {
      userName = decodedToken.lekar || "No doctor name!";
      UIN = decodedToken.uin || "No UIN!";
    } else if (role === "affiliate") {
      userName = decodedToken.affiliate || "No affiliate name!";
    }
    profilRegister = decodedToken.profilregister || "";
    if (profilRegister === 1)
      profilEmail = decodedToken.profilemail || "No email !!!!";
  }
  localStorage.setItem("profilRegister", profilRegister);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const triggerRef = React.useRef(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleProfile = () => {
    setAnchorEl(null);
    navigate("/profile", { state: { profilEmail } });
  };
  const handleLogout = () => {
    localStorage.clear();
    setAnchorEl(null);
    dispatch(logout());
    navigate("/");
  };
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexGrow: 0,
          borderBottom: `2px solid ${config.footerBarColor}`,
          bgcolor: config.appBarBGColor,
          height: !isMobile ? "115px" : "70px",
          alignItems: "center",
          // marginTop: "30px",
        }}
      >
        <AppBar
          position="static"
          className="header"
          sx={{
            boxShadow: "none",
            flexShrink: 0,
            color: "#6e1646",
            textAlign: "center",
            padding: "0 20px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // justifyContent: "center",
            bgcolor: config.appBarBGColor,
            "& .MuiTypography-root": {
              marginTop: !isMobile ? "2px" : "2px",
              height: !isMobile ? "110px" : "55px",
            },
            "&header.MuiPaper-root": {
              padding: "0 !important",
              height: "100%",
            },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{
              display: "flex",
              flexGrow: 1,
              alignItems: "center",
              justifyContent: "center",
              // marginTop: "5px",
              height: "100%", // Match the parent
              width: "100%",
              bgcolor: config.appBarBGColor,
            }}
          >
            {role === "patient" && (
              <Fragment>
                <AccountCircleOutlinedIcon
                  ref={triggerRef}
                  id="fade-button"
                  aria-controls={open ? "fade-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  className="iconPacient"
                  sx={{
                    fontSize: "2rem",
                    color: config.appBarColor,
                    bgcolor: config.appBarBGColor,
                    cursor: "pointer",
                  }}
                ></AccountCircleOutlinedIcon>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    "& div.MuiPaper-root": {
                      color: config.appBarColor,
                      bgcolor: config.appBarBGColor,
                      padding: 0,
                    },
                    "&hover": {
                      backgroundColor: config.buttonSearchColorHover,
                    },
                    "& .MuiMenuItem-root": {
                      padding: "5px", // Removes padding from MenuItem elements
                    },
                  }}
                >
                  {profilRegister === 1 && (
                    <MenuItem
                      onClick={handleProfile}
                      // component="a"
                      // href="/profile"
                      // target="_blank"
                      // rel="noopener noreferrer"
                      // onClick={(e) => {
                      //   if (e.button === 0) handleProfile(); // Left click
                      // }}
                      // onContextMenu={(e) => {
                      //   e.stopPropagation(); // Allow default right-click menu
                      // }}
                    >
                      Профил
                    </MenuItem>
                  )}
                  <MenuItem onClick={handleLogout}>Изход</MenuItem>
                </Menu>
              </Fragment>
            )}

            {role === "doctor" && (
              <Fragment>
                <AccountCircleOutlinedIcon
                  ref={triggerRef}
                  id="fade-button"
                  aria-controls={open ? "fade-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  className="iconDoctor"
                  sx={{
                    fontSize: "2rem",
                    color: config.appBarColor,
                    bgcolor: config.appBarBGColor,
                    cursor: "pointer",
                  }}
                ></AccountCircleOutlinedIcon>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    "& div.MuiPaper-root": {
                      color: config.appBarColor,
                      bgcolor: config.appBarBGColor,
                    },
                    "&hover": {
                      backgroundColor: config.buttonSearchColorHover,
                    },
                  }}
                >
                  {profilRegister === 1 && (
                    <MenuItem onClick={handleProfile}>Профил</MenuItem>
                  )}
                  <MenuItem onClick={handleLogout}>Изход</MenuItem>
                </Menu>
              </Fragment>
            )}

            {role === "affiliate" && (
              <Fragment>
                <AccountCircleOutlinedIcon
                  ref={triggerRef}
                  id="fade-button"
                  aria-controls={open ? "fade-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  className="iconAffiliate"
                  sx={{
                    fontSize: isMobile ? "1.7rem" : "2.2rem",
                    color: config.appBarColor,
                    bgcolor: config.appBarBGColor,
                    cursor: "pointer",
                  }}
                ></AccountCircleOutlinedIcon>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    "& div.MuiPaper-root": {
                      color: config.appBarColor,
                      bgcolor: config.appBarBGColor,
                    },
                    "&hover": {
                      backgroundColor: config.buttonSearchColorHover,
                    },
                  }}
                >
                  {profilRegister === 1 && (
                    <MenuItem onClick={handleProfile}>Профил</MenuItem>
                  )}
                  <MenuItem onClick={handleLogout}>Изход</MenuItem>
                </Menu>
              </Fragment>
            )}
            <a
              href={config.labHomePageUrl}
              id="logo-button"
              aria-label="Go to Home Page"
              style={{
                display: "flex", // Ensures the link container grows
                alignItems: "center",
                justifyContent: "center",
                height: !isMobile ? "100%" : "auto", // Match the header height
                width: !isMobile ? "15%" : "50%", // Ensure it scales
                maxWidth: "250px",
              }}
            >
              <img
                id="logo"
                src={config.logoPath}
                alt="Logo"
                style={{
                  width: "100%",
                  height: "auto",
                  maxWidth: "100%",
                  maxHeight: !isMobile ? "100px" : "55px", // Adjust as needed
                  objectFit: "contain",
                  padding: "5px",
                  margin: 0,
                }}
              />
            </a>
            {/* <img id="logo" src={config.logoPath} alt="Logo" /> */}
            {(role === "patient" ||
              role === "doctor" ||
              role === "affiliate") && (
              <IconButton
                className="iconMenu"
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{
                  mr: 2,
                  backgroundColor: "transparent",
                  right: "4vw",
                  position: "fixed",
                }}
              >
                <FadeMenu sx={{ top: "30px" }} />
              </IconButton>
            )}
          </Typography>
        </AppBar>
      </Box>
      {location.pathname !== "/" && (
        <div
          className="user-info"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "5px",
            justifyContent: "center",
            color: config.footerBarColor,
            fontSize: "15px",
          }}
        >
          {/* {role === "doctor" ? `${userName} УИН: ${UIN}` : userName} */}
          <div className="user-info">
            {role === "doctor" ? `${userName} УИН: ${UIN}` : userName}
          </div>
          {role === "patient" &&
            (profilRegister === 2 || profilRegister === 3) && (
              <Alert
                severity={profilRegister === 2 ? "warning" : "info"}
                sx={{
                  margin: "2px",
                  backgroundColor: profilRegister === 2 ? "#fff3e0" : "#e3f2fd",
                  fontSize: isMobile ? "10px" : "14px",
                  padding: isMobile ? 0 : "2px",
                  borderRadius: "8px",
                  boxShadow: 2,
                }}
                hidden={profilRegister === 1}
              >
                {profilRegister === 2 &&
                  `Моля свържете се с лабораторията на тел: ${config.phone} или ел. поща: ${config.email} , за да ви бъде създаден пълен достъп до вашето досие!`}
                {profilRegister === 3 &&
                  "Вие сте регистриран потребител. Моля да влезете с вашия имейл, за да имате достъп до всички резултати!"}
              </Alert>
            )}
        </div>
      )}
    </Fragment>
  );
}
export default AppHeader;
